import {
    UserState,
    USER_LOGIN,
    USER_LOGIN_FAILED,
    USER_LOGOUT,
    UserActionTypes,
    User,
    USER_SAVE_FAILED,
    USER_SAVE,
    SUPPLIER_ID_CHANGE
} from "./types";
import {clearState} from "../index";

const initialState: UserState = {
    isLoggedIn: false,
    user: undefined,
    supplierId: undefined
};

export function userReducer(
    state = initialState,
    action: UserActionTypes
): UserState {
    switch (action.type) {
        case USER_LOGIN:
            return {
                isLoggedIn: true,
                user: action.payload,
                message: undefined
            };
        case USER_LOGIN_FAILED:
            return {
                isLoggedIn: false,
                user: undefined,
                message: action.payload
            };
        case USER_LOGOUT:
            clearState();
            return {
                isLoggedIn: false,
                user: undefined,
                message: undefined
            };
        case USER_SAVE:
            return {
                isLoggedIn: true,
                user: action.payload,
                message: undefined
            };
        case USER_SAVE_FAILED:
            return {
                isLoggedIn: true,
                message: action.payload
            };
        case SUPPLIER_ID_CHANGE:
            return {
                isLoggedIn: true,
                user: state.user,
                supplierId: action.payload
            };
        default:
            return state;
    }
}
